import { isCollectStep } from "@jslib/shared/runtimeTypes";

import Message from "@components/Message";

import { useProgramTheme, useVerificationResponse } from "@/lib/state/contextHooks";

import { isCaptchaEnabled } from "@/lib/ProgramTheme/programThemeGetters";

import { useFlag } from "../FeatureFlags/hooks";

const FooterText = () => {
  const { currentStep } = useVerificationResponse();
  const programTheme = useProgramTheme();
  const captchaEnabledFlag = useFlag("captcha") === "enabled";
  const captchaEnabled = isCaptchaEnabled(programTheme) || captchaEnabledFlag;

  const footerClassName = "sid-footer__text";

  return (
    <div className={footerClassName}>
      {/**
       * By passing currentStep into the Translation, we enable the potential of
       * step specific overrides e.g. footerText_docUpload, while also only needing to
       * maintain a single default message.
       */}
      <Message id="footerText" context={currentStep} />

      {captchaEnabled && isCollectStep(currentStep) && (
        <p className="sid-footer__captcha-text">
          <Message id="captchaFooterText" />
        </p>
      )}
    </div>
  );
};

export { FooterText };
